import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { ApiService } from '../../../../../../common/services/api.service';
import { CustomValidators } from '../../../../../../common/shared/custom-validators';

@Component({
  selector: 'app-password-recovery',
  templateUrl: './password-recovery.component.html',
  styleUrls: ['./password-recovery.component.scss'],
})

export class PasswordRecoveryComponent {

  recoveryForm: FormGroup = this.createForm();

  constructor(public dialogRef: MatDialogRef<PasswordRecoveryComponent>, private formBuilder: FormBuilder, private api: ApiService, private router: Router) { }

  createForm(): FormGroup {
    return this.formBuilder.group({
      login: [null, [Validators.required, Validators.minLength(6), CustomValidators.validateEmail]],
    });
  }

  sendRequest() {
    if (this.recoveryForm.invalid) {
      this.recoveryForm.markAllAsTouched();
      return this.api.logError('formErrors.invalidForm');
    }
    const data = this.recoveryForm?.getRawValue();
    this.api.recoverPassword(data).subscribe(() => {
      this.api.log('---Email enviado ', true);
      this.close();
    });
  }

  close() {
    this.dialogRef.close();
  }
}
